import { DESKTOP } from "@/themes/device";
import styled from "@emotion/styled";
import {
  grayScale,
  mBody1,
  mBody3,
  mTitle2,
  wHeader1,
  wHeader2,
  wTitle4,
} from "@teamsparta/design-system";

export const Wrapper = styled.div`
  background-color: ${grayScale.gray0};
  padding-top: 120px;

  ${DESKTOP} {
    padding: 108px 0 48px 0;
  }
`;

export const ContentsWrapper = styled.section`
  width: calc(100% - 32px);
  margin: 0 auto;

  ${DESKTOP} {
    max-width: 1152px;
    display: flex;
    justify-content: space-between;
  }
`;

export const SubTitle = styled.small`
  display: block;
  ${mTitle2}
  color: ${grayScale.gray70};

  ${DESKTOP} {
    ${wTitle4}
    color: ${grayScale.gray70};
    padding-top: 72px;
  }
`;

export const Title = styled.h1`
  ${wHeader2}
  color: ${grayScale.gray100};
  margin-top: 10px;

  ${DESKTOP} {
    ${wHeader1}
    color: ${grayScale.gray100};
    margin-top: 16px;
  }
`;

export const Desc = styled.p`
  width: 328px;
  position: absolute;
  top: 552px;
  ${mBody1}
  font-weight: 400;
  color: ${grayScale.gray70};
  word-break: keep-all;
  line-height: 160%;

  ${DESKTOP} {
    font-weight: 500;
    font-size: 16px;
    width: 532px;
    position: absolute;
    top: 378px;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 328px;
  height: 328px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 126px;

  ${DESKTOP} {
    width: 420px;
    height: 420px;
    margin-top: 0;
    transform: none;
    top: 0;
    left: 0;
  }
`;
